import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { OidcService } from '@revenuewell/logic-oidc';

export interface ILocation {
    id: number;
    name: string;
    crmAccountId: string;
    idMasterAccount: number;
    rwAccountId: string;
    addressLine1: string;
    addressLine2: string;
    addressCity: string;
    addressPostalCode: string;
    addressState: string;
    phone: string;
    accountStatus: number;
    timezone: string;
    idNetwork: number;
    isCommunicationActive: boolean;
}

export default class LocationService extends AuthApiService {
    private static instance: LocationService;

    private config: any;
    private accountApiUrl: string;

    private constructor(config: any, oidcService: OidcService) {
        super(oidcService, new NavigationService());
        this.config = config;
        this.accountApiUrl = config.account?.apiUrl;
        return this;
    }

    public static getInstance(config: any, oidcService: OidcService) {
        if (!LocationService.instance) LocationService.instance = new LocationService(config, oidcService);

        return LocationService.instance;
    }

    public async getLocation(locationId: number): Promise<ILocation> {
        const url = `${this.accountApiUrl}/locations/${locationId}`;

        const response = await this.authFetch(url, { method: 'GET' }, { ttlSeconds: 60 });
        const data: ILocation = await response.json();

        return data;
    }

    public async getAvailableLocations(masterAccountId: number): Promise<ILocation[]> {
        const url = `${this.accountApiUrl}/master-accounts/${masterAccountId}/locations`;
        const response = await this.authFetch(url, { method: 'GET' }, { ttlSeconds: 60 });
        return await response.json();
    }
}
